import type { FloorPlanSnapshotData } from '@shared/types/floorPlans';
import { api } from '../../api';

export const getFloorPlanSnapshotForReservationId = async (
  reservationId: string,
) =>
  api.get<FloorPlanSnapshotData>(
    `/reservations/${reservationId}/floor-plan-snapshot`,
  );
